var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.279,123.753l7.121,7.121a.879.879,0,0,1,0,1.244l-.831.831a.879.879,0,0,1-1.242,0l-5.67-5.643-5.67,5.643a.879.879,0,0,1-1.242,0l-.831-.831a.879.879,0,0,1,0-1.244l7.121-7.121a.879.879,0,0,1,1.244,0Z","transform":"translate(-5.657 -123.495)","fill":"#fff"}));
}

ChevronUp.defaultProps = {"width":"16","height":"9.71","viewBox":"0 0 16 9.71"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
